import React from 'react';

import { Typography } from 'antd';

import BaseForm from 'components/BaseForm/BaseForm';
import BaseUploader from 'components/BaseForm/BaseUploader';
import { useSubmitApurementDossier } from 'pages/admin-fonctionnel/AdministrationAvancee/ApurementDossier/useSubmitApurementDossier';
import { useValidateFieldApurementDossier } from 'pages/admin-fonctionnel/AdministrationAvancee/ApurementDossier/useValidateFieldApurementDossier';
import { CSSUtils } from 'utils/CSSUtils';

import { CollapsableContainer } from '../CollapsableContainer';

import '../ActionCommon.less';
import './ApurementDossier.less';

const ApurementDossier = () => {
  const { validateApurementField, isPending: validationIsPending } =
    useValidateFieldApurementDossier();
  const {
    submitApurement,
    isPending: submitIsPending,
    submitAlertMessage,
    getReportAlertMessage,
  } = useSubmitApurementDossier();

  return (
    <CollapsableContainer
      title={'Destruction en masse des dossiers'}
      alertMessage={getReportAlertMessage || submitAlertMessage}
    >
      <div className={'dossierSuppressionMasseContainer'}>
        <Typography.Text>
          Le fichier CSV doit contenir une colonne
          <Typography.Text code>id_dossier</Typography.Text> avec les
          identifiants des dossiers à supprimer.
        </Typography.Text>
        <BaseForm
          wrapperCol={{ span: CSSUtils.fullWidthCol }}
          onSubmit={submitApurement}
          isSubmitting={submitIsPending || validationIsPending}
          initialValues={{}}
          validateField={validateApurementField}
          inputs={[
            {
              field: 'FILE',
              name: 'file',
              required: true,
              render: () => {
                return <BaseUploader placeholder={'Insérer le fichier CSV'} />;
              },
            },
          ]}
          submitText={'Passer en destruction'}
          renderButtonAction={Submit => {
            return <div>{Submit}</div>;
          }}
        />
      </div>
    </CollapsableContainer>
  );
};

export default ApurementDossier;
